import React, { useState, useEffect } from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import photoIcon from "../../Assets/images/svg/Icons/file-image-svgrepo-com.svg";
import GroupIcon from "../../Assets/images/svg/Icons/Group 578.svg";
import "../../Components/Common/Styles/Formstyles.css";
import { DeleteApiMethod, GetApiMethod } from "../../Utils/ApiService";
import { FormDataType } from "./FormTypes";

interface PhotosFormProps {
  formData: any;
  setFormData: (data: any) => void;
  handleNext?: () => void;
  handleBack?: () => void;
  title?: string;
  type?: "banner" | "photo";
}

const UploadBox = styled(Box)({
  border: "2px dashed #ccc",
  borderRadius: "10px",
  padding: "20px",
  textAlign: "center",
  cursor: "pointer",
  width: "100%",
  height: 150,
});

const ImagePreview = styled("img")({
  width: "80px",
  height: "80px",
  borderRadius: "8px",
  objectFit: "cover",
});

const PhotosForm: React.FC<PhotosFormProps> = ({
  formData,
  setFormData,
  handleNext,
  handleBack,
  title = "Upload Photos (For Portfolio)",
  type,
}) => {
  const [newPhotos, setNewPhotos] = useState<File[]>([]);
  const [uploadedPhotos, setUploadedPhotos] = useState<any[]>([]);
  
useEffect(() => {
    if (!formData.providerId) {
    console.log("No formData.id present, skipping fetch");
    return;
  }

  const fetchPortfolio = async () => {
    if (!formData.providerId) return;
    try {
      const res = await GetApiMethod(`provider-portfolio/list?id=${formData.providerId}`);
      if (res.data.status === "success" && Array.isArray(res.data.data.records)) {
        console.log("Raw portfolio records:", res.data.data.records);
      const backendPhotos = res.data.data.records
  .filter((p: any) => p.mediaType && p.mediaType.startsWith("image")) // Only images
  .map((p: any) => ({
    id: p.id,
    media: p.mediaUrl || p.media,
    mediaType: p.mediaType,
  }));


        console.log("Mapped backend photos:", backendPhotos);
        setUploadedPhotos(backendPhotos);

        // Keep only File objects from formData
        const files = formData.photos?.filter((f: any) => f instanceof File) || [];

        // Merge cleanly
        setFormData((prev: FormDataType) => ({
          ...prev,
          photos: [...backendPhotos, ...files],
        }));
      }
    } catch (err) {
      console.error("Failed to fetch portfolio:", err);
    }
  };
  fetchPortfolio();
}, [formData.providerId]);
// useEffect(() => {
//   console.log("useEffect triggered, formData.id:", formData.providerId);

//   const fetchPortfolio = async () => {
//     if (!formData.providerId) {
//       console.log("No formData.id present, exiting fetchPortfolio");
//       return;
//     }
//     // rest of your code
//   };

//   fetchPortfolio();
// }, [formData.providerId]);

  // Prefill existing photos on mount
 useEffect(() => {
  if (formData.photos && Array.isArray(formData.photos)) {
  const uploaded = formData.photos.filter(
  (f: any) => f instanceof File || f.id || typeof f === "string"
);
const existing = uploaded.filter((f: any) => !(f instanceof File)); // only backend uploads
setUploadedPhotos(existing);
  }
}, [formData.photos]);

  // Handle new uploads
  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const newFiles = Array.from(files);
    setNewPhotos((prev) => [...prev, ...newFiles]);

    setFormData((prev: any) => ({
      ...prev,
      photos: [...uploadedPhotos, ...prev.photos.filter((f: any) => f instanceof File), ...newFiles],
    }));
  };

  // Delete uploaded photo
const handleDeletePhoto = async (id?: string, newIndex?: number) => {
  console.log("Delete clicked:", { id, newIndex });

  // Case 1: Deleting a newly added (unsaved) photo by its index in newPhotos
  if (typeof newIndex === "number") {
    const updatedNew = newPhotos.filter((_, i) => i !== newIndex);
    setNewPhotos(updatedNew);
    setFormData((prev: FormDataType) => ({
      ...prev,
      photos: [...uploadedPhotos, ...updatedNew], // sync formData photos
    }));
    return;
  }

  // Case 2: Deleting an existing (uploaded) photo by its id
  if (!id) {
    console.error("No ID found for photo deletion");
    return;
  }

  try {
    console.log("Deleting photo with ID:", id);
    await DeleteApiMethod(`provider-portfolio/${id}`);

    // Remove photo from uploadedPhotos state
    const updated = uploadedPhotos.filter((photo) => photo.id !== id);
    setUploadedPhotos(updated);

    // Update formData.photos to keep in sync with both uploaded and new photos
    setFormData((prev: FormDataType) => ({
      ...prev,
      photos: [...updated, ...newPhotos],
    }));

    console.log("Photo deleted successfully");
  } catch (err) {
    console.error("Failed to delete photo:", err);
    alert("Failed to delete photo");
  }
};

  const handleNextStep = () => {
    if (handleNext) handleNext();
  };

  return (
    <Box>
      <Typography className="form-input" mt={3}>{title}</Typography>

      <UploadBox as="label">
         <img src={photoIcon} alt="Upload icon" style={{ marginTop: 15, width: 40 }} />
        <Typography fontSize="14px" mt={1} fontFamily="Poppins">
          Drag and drop photos or <span style={{ color: "#3E93E8", cursor: "pointer" }}>Choose file</span>
        </Typography>
        <input
          type="file"
          hidden
          accept="image/*"
          multiple={type !== "banner"}
          onChange={handlePhotoUpload}
        />
      </UploadBox>

    <Box display="flex" gap={2} flexWrap="wrap" mt={2} mb={3}>
  {newPhotos.map((photo, index) => (
    <Box
      key={`new-${photo.name}-${photo.lastModified}`} // unique key for new files
      position="relative"
      display="inline-block"
    >
      <ImagePreview src={URL.createObjectURL(photo)} alt={`photo-${index}`} />
      <IconButton
        size="small"
        onClick={() => handleDeletePhoto(undefined, index)}
        sx={{ position: "absolute", top: "-10px", right: "-10px", backgroundColor: "white" }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  ))}

  {uploadedPhotos.map((photo) => 
  { console.log("Rendering uploaded photo:", photo);
    const src = typeof photo === "string" ? photo : photo.media || photo.url;
    return (
      <Box
        key={photo.id || photo.media || Math.random()} // unique key for uploaded photos
        position="relative"
        display="inline-block"
      >
        <ImagePreview src={src} alt={photo.id || "uploaded-photo"} />
        <IconButton
          size="small"
          onClick={() => handleDeletePhoto(photo.id)}
          sx={{ position: "absolute", top: "-10px", right: "-10px", backgroundColor: "white" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    );
  })}
</Box>


      <Box display="flex" gap={2}>
        {handleBack && (
          <Button onClick={handleBack} className="btn-back">
            <Box component="img" src={GroupIcon} sx={{ mr: 1 }} />
            Back
          </Button>
        )}
        {handleNext && (
          <Button onClick={handleNextStep} className="btn-next">
            Next
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default PhotosForm;
